import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TbAlertTriangleFilled } from 'react-icons/tb';
import { useLocation } from 'react-router';

import { APPS } from '@cccom/config/app-config';
import { useEnvironment } from '@cccom/config/env';
import { useSettings } from '@cccom/shared/settings';
import { Button } from '@cccom/ui/src/components/shadcn/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from '@cccom/ui/src/components/shadcn/dialog';

export function HasValidRolesModal() {
  const [t] = useTranslation();
  const { pathname } = useLocation();
  const env = useEnvironment();
  const isHome = pathname === '/apps';

  const { hasValidRoles } = useSettings();
  const [openDialog, setOpenDialog] = useState(!hasValidRoles);

  const handleClose = () => {
    if (isHome) {
      setOpenDialog(false);
    } else {
      window.location.href = APPS.getUrl(env, APPS.HOME);
    }
  };

  useEffect(() => setOpenDialog(!hasValidRoles), [hasValidRoles]);

  return (
    <Dialog open={openDialog}>
      <DialogOverlay className="bg-black/60" />
      <DialogContent className="border-t-0 sm:max-w-md" showCloseButton={false}>
        <div className="border-primary fixed w-full rounded-t-lg border-t-4 bg-white" />
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 pt-1 text-sm">
            <TbAlertTriangleFilled className="fill-orange-400" />
            {t('permission.access_restricted_conflicting_roles')}
          </DialogTitle>
        </DialogHeader>

        <DialogDescription>
          <Trans i18nKey="permission.access_restricted_conflicting_roles_blurb" />
        </DialogDescription>

        <DialogFooter>
          <Button
            className="mt-4 w-full"
            variant="outline"
            onClick={handleClose}
          >
            {t('common.actions.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
